/** Category tree nodes / facet ids are base64(numericId) (GET /api/intern/categories). */
export function decodeCategoryId(encoded: string): number {
  try {
    return Number.parseInt(atob(encoded), 10)
  }
  catch {
    return Number.NaN
  }
}
